"use strict";
exports.__esModule = true;
var metalog_chart_maker_1 = require("../logic/metalog-chart-maker");
var MetalogChartMaker = metalog_chart_maker_1["default"].MetalogChartMaker;
var metalog_1 = require("../logic/metalog");
angular.module('smartorg.r6.acts.metalog').directive('metalogChart', ["$timeout", function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/metalog.html'),
            scope: {
                menu: '='
            },
            link: function (scope) {
                scope.showCDF = true;
                var showMetalog = function (args) {
                    var metalogData = args.config.data;
                    console.log(args);
                    scope.actionMenuItem = args.actionMenuItem;
                    scope.inputData = metalogData.tornados;
                    scope.nodeName = metalogData.nodeName;
                    scope.colors = metalogData.colors;
                    scope.depth = metalogData.depth;
                    scope.depthResult = Math.pow(3, scope.depth);
                    scope.weights = metalogData.weights;
                    scope.tornadoActionID = metalogData.tornadoActionID;
                    scope.failureBranchExist = metalogData.failureBranchExist;
                    scope.fittedPointExplanation = metalogData.fittedPointExplanation;
                    scope.showFittedPointsHelp = false;
                    scope.showTable = false;
                    scope.decimals = 2;
                    scope.timestampMode = 'lastRecalc';
                    scope.timestamp = null;
                    var portfolioName = args.treeName;
                    if (localStorage.getItem('PortfolioConfig') &&
                        portfolioName in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
                        var portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[portfolioName];
                        scope.showTable = portfolioConfig['chart']['showTable'] != "false";
                        scope.decimals = portfolioConfig['chart']['decimals'];
                        scope.showTooltip = portfolioConfig['chart']['showTooltip'] != "false";
                        scope.showChartExplanation = portfolioConfig['chart']['showChartExplanation'] != "false";
                        if (portfolioConfig['timestamp']) {
                            scope.timestampMode = portfolioConfig['timestamp']['timestampMode'];
                        }
                    }
                    else if (metalogData.settings) {
                        scope.showTable = metalogData.settings.showTable != "false";
                        scope.decimals = metalogData.settings.decimals;
                        scope.showTooltip = metalogData.settings.showTooltip != "false";
                        scope.showChartExplanation = metalogData.settings.showChartExplanation != "false";
                        scope.timestampMode = metalogData.settings.timestampMode || 'lastRecalc';
                    }
                    if (scope.decimals == "Default") {
                        if (metalogData.settings.defaultPrecision) {
                            scope.decimals = metalogData.settings.defaultPrecision;
                        }
                        else {
                            scope.decimals = null;
                        }
                    }
                    scope.timestamp = scope.timestampMode === 'lastRecalc' ? args.nodeLastRecalc : null;
                    if (scope.showTableOnReload &&
                        (scope.actionMenuItem == scope.actionMenuItemOnReload)) {
                        scope.showTable = scope.showTableOnReload;
                    }
                    scope.expandChartExplanation = false;
                    scope.hasCorrectCoeffients = true;
                    scope.mvs = metalogData.mvsOutput.MVSFromFittedPoints;
                    var index = 0;
                    scope.submissionIndex = index;
                    if (scope.selectedInputDataOnReload &&
                        (scope.actionMenuItem == scope.actionMenuItemOnReload)) {
                        for (var i = 0; i < scope.inputData.length; i++) {
                            if (scope.selectedInputDataOnReload.Display == scope.inputData[i].Display) {
                                index = i;
                                scope.submissionIndex = index;
                                break;
                            }
                        }
                    }
                    scope.selectedInputData = scope.inputData[index];
                    var submissions = metalogData.submissions, shadowSubmissions = metalogData.shadowSubmissions;
                    scope.submissions = { submissions: submissions, shadowSubmissions: shadowSubmissions };
                    // TODO: use this
                    scope.mean = metalogData.mvsOutput.MVSFromFittedPoints.find(function (o) { return o.Key === scope.selectedInputData.Key; }).Mean;
                    scope.skewness = metalogData.mvsOutput.MVSFromFittedPoints.find(function (o) { return o.Key === scope.selectedInputData.Key; }).Skewness;
                    scope.variance = metalogData.mvsOutput.MVSFromFittedPoints.find(function (o) { return o.Key === scope.selectedInputData.Key; }).Variance;
                    scope.hasCorrectCoeffients = scope.selectedInputData.MetaLogOutputs.FittedPoints.Probabilities.length != 1;
                    if (metalogData.shadowmvsOutput) {
                        scope.shadowMVS = metalogData.shadowmvsOutput.MVSFromFittedPoints;
                        scope.shadowMean = metalogData.shadowmvsOutput.MVSFromFittedPoints[0].Mean;
                        scope.shadowSkewness = metalogData.shadowmvsOutput.MVSFromFittedPoints[0].Skewness;
                        scope.shadowVariance = metalogData.shadowmvsOutput.MVSFromFittedPoints[0].Variance;
                    }
                    if (scope.failureBranchExist) {
                        scope.sumOfProbability = metalog_1.FailureBranch.sumProbability(metalogData.failureBranchStages);
                        scope.sumOfSubtractionValue = metalog_1.FailureBranch.sumSubtractionValue(metalogData.failureBranchStages);
                        scope.arrayOfFailureBranchPoints = metalog_1.FailureBranch.arrayFailureBranchPoints(metalogData.failureBranchStages);
                    }
                    if (metalogData.shadowTornados) {
                        scope.shadowInputData = metalogData.shadowTornados;
                        scope.shadowNodeName = metalogData.shadowNodeName;
                    }
                    else {
                        scope.shadowInputData = undefined;
                    }
                    scope.allFeasiblePanels = new metalog_1.MetaLogPanel(scope.selectedInputData.MetaLogOutputs.Panel).allFeasiblePanels();
                    scope.selectedTerm = metalog_1.MetaLogPanel.getSelectedTerm(scope.allFeasiblePanels);
                    if (!scope.shadowInputData) {
                        scope.selectedShadowInputData = null;
                        scope.shadowNodeName = null;
                    }
                    else {
                        scope.selectedShadowInputData = scope.shadowInputData[0];
                        var allFeasiblePanelsShadow = new metalog_1.MetaLogPanel(scope.selectedShadowInputData.MetaLogOutputs.Panel).allFeasiblePanels();
                        if (allFeasiblePanelsShadow && allFeasiblePanelsShadow.length) {
                            scope.selectedTermShadow = allFeasiblePanelsShadow[allFeasiblePanelsShadow.length - 1].NumberOfTerms;
                        }
                        else {
                            scope.selectedTermShadow = null;
                        }
                    }
                    scope.drawMetalogGraph();
                    scope.initMenu();
                    setTimeout(function () {
                        scope.$apply();
                    }, 0);
                };
                scope.$on('command:METALOG_DISPLAY', function (event, args) {
                    showMetalog(args);
                });
                scope.gotoTornado = function () {
                    scope.$emit("workbench:redirect", {
                        menu: scope.tornadoActionID
                    });
                };
                scope.selectNewData = function (selectedInputData) {
                    scope.actionMenuItemOnReload = angular.copy(scope.actionMenuItem);
                    scope.selectedInputDataOnReload = angular.copy(selectedInputData);
                    scope.selectedInputData = selectedInputData;
                    scope.hasCorrectCoeffients = selectedInputData.MetaLogOutputs.FittedPoints.Probabilities.length != 1;
                    for (var i = 0; i < scope.mvs.length; i++) {
                        if (scope.selectedInputData.Key === scope.mvs[i].Key) {
                            scope.mean = scope.mvs[i].Mean;
                            scope.skeness = scope.mvs[i].Skewness;
                            scope.variance = scope.mvs[i].Variance;
                            scope.submissionIndex = i;
                        }
                    }
                    if (scope.shadowMVS) {
                        for (var i = 0; i < scope.shadowMVS.length; i++) {
                            if (scope.selectedInputData.Key === scope.shadowMVS[i].Key) {
                                scope.shadowMean = scope.shadowMVS[i].Mean;
                                scope.shadowSkewness = scope.shadowMVS[i].Skewness;
                                scope.shadowVariance = scope.shadowMVS[i].Variance;
                            }
                        }
                    }
                    scope.allFeasiblePanels = new metalog_1.MetaLogPanel(scope.selectedInputData.MetaLogOutputs.Panel).allFeasiblePanels();
                    scope.selectedTerm = metalog_1.MetaLogPanel.getSelectedTerm(scope.allFeasiblePanels);
                    if (scope.shadowInputData) {
                        for (var i = 0; i < scope.shadowInputData.length; i++) {
                            if (scope.shadowInputData[i].Display == selectedInputData.Display) {
                                scope.selectedShadowInputData = scope.shadowInputData[i];
                            }
                        }
                    }
                    if (!scope.showCDF) {
                        scope.changeChart();
                    }
                    else {
                        scope.showCDF = true;
                        scope.initMenu();
                        scope.drawMetalogGraph();
                    }
                    if (scope.showTable === true) {
                        scope.showTable = true;
                    }
                    if (scope.fittedPointExplanation === true) {
                        scope.fittedPointExplanation = true;
                    }
                };
                function fixCell(value) {
                    return isNaN(value) ? '"' + value + '"' : value;
                }
                scope.exportCsv = function (EU) {
                    if (EU === void 0) { EU = false; }
                    var chartMaker = new MetalogChartMaker(scope.selectedInputData, scope.selectedShadowInputData, scope.shadowNodeName, scope.nodeName, scope.colors, scope.showTooltip, scope.decimals, scope.timestamp);
                    // var tableCSV = chartMaker.fittedPointsOnCDF(chartMaker.inputData);
                    var tableCSV = scope.displayTable;
                    if (scope.selectedShadowInputData !== null) {
                        var tableCSVShadow = chartMaker.fittedPointsOnCDF(chartMaker.shadowInputData);
                    }
                    var tocsv = function () {
                        var csv = "";
                        if (scope.selectedShadowInputData !== null) {
                            csv += "NodeName:" + scope.nodeName + "\n";
                            csv += "Probability, Cumulative Probability, " + scope.selectedInputData.Display + "\n";
                            csv += fixCell(tableCSV[0][1]) + "," + fixCell(tableCSV[0][1]) + "," + fixCell(tableCSV[0][0]) + "\n";
                            for (var i = 1; i < tableCSV.length; i++) {
                                csv += fixCell(tableCSV[i][1] - tableCSV[i - 1][1]) + "," + fixCell(tableCSV[i][1]) + "," + fixCell(tableCSV[i][0]) + "\n";
                            }
                            csv += "Moment, Mean, Variance, Skewness" + "\n";
                            csv += "Value," + fixCell(scope.mean) + ", " + fixCell(scope.variance) + ", " + fixCell(scope.skewness) + "\n";
                            csv += "NodeName:" + scope.shadowNodeName + "\n";
                            csv += "Probability, Cumulative Probability, Value\n";
                            csv += fixCell(tableCSVShadow[0][1]) + "," + fixCell(tableCSVShadow[0][1]) + "," + fixCell(tableCSVShadow[0][0]) + "\n";
                            for (var i = 1; i < tableCSVShadow.length; i++) {
                                csv += fixCell(tableCSVShadow[i][1] - tableCSVShadow[i - 1][1]) + "," + fixCell(tableCSVShadow[i][1]) + "," + fixCell(tableCSVShadow[i][0]) + "\n";
                            }
                            csv += "Moment, Mean, Variance, Skewness" + "\n";
                            csv += "Value," + fixCell(scope.shadowMean) + ", " + fixCell(scope.shadowVariance) + ", " + fixCell(scope.shadowSkewness) + "\n";
                        }
                        else {
                            csv += "NodeName:" + scope.nodeName + "\n";
                            csv += "Probability, Cumulative Probability, " + scope.selectedInputData.Display + "\n";
                            csv += fixCell(tableCSV[0][1]) + "," + fixCell(tableCSV[0][1]) + "," + fixCell(tableCSV[0][0]) + "\n";
                            for (var i = 1; i < tableCSV.length; i++) {
                                csv += fixCell(tableCSV[i][1] - tableCSV[i - 1][1]) + "," + fixCell(tableCSV[i][1]) + "," + fixCell(tableCSV[i][0]) + "\n";
                            }
                            csv += "Moment, Mean, Variance, Skewness" + "\n";
                            csv += "Value," + fixCell(scope.mean) + ", " + fixCell(scope.variance) + ", " + fixCell(scope.skewness) + "\n";
                        }
                        return csv;
                    };
                    var csv = tocsv();
                    if (EU) {
                        csv = csv.replace(/,/g, ';');
                        csv = csv.replace(/\./g, ',');
                    }
                    var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
                    var currentDate = chartMaker.getDate();
                    var filename = "Points_" + scope.nodeName + "_" + currentDate + ".csv";
                    saveAs(blob, filename);
                };
                scope.exportCharts = function () {
                    var exporter = new smartorg.r6.lib.ChartExporter("metalogChart", "svg-canvas");
                    var title = scope.actionMenuItem + " for " +
                        scope.nodeName;
                    exporter.exportChart(title, true);
                };
                scope.drawMetalogGraph = function () {
                    scope.showCDF = true;
                    scope.changeChart();
                };
                scope.changeChart = function () {
                    var chartMaker = new MetalogChartMaker(scope.selectedInputData, scope.selectedShadowInputData, scope.shadowNodeName, scope.nodeName, scope.colors, scope.showTooltip, scope.decimals, scope.timestamp);
                    var failureBranch = undefined;
                    var drawFittedPoints = true;
                    if (scope.showCDF) {
                        if (scope.failureBranchExist) {
                            // drawFittedPoints = false;
                            failureBranch = {
                                "probability": scope.sumOfProbability,
                                "subtractionValue": scope.sumOfSubtractionValue,
                                "arrayOfFailureBranchPoints": scope.arrayOfFailureBranchPoints
                            };
                        }
                        chartMaker.initialize(scope.selectedTerm, failureBranch, scope.selectedTermShadow);
                        scope.fittedPoints = drawFittedPoints ? handleFittedPoints(chartMaker) : null;
                        chartMaker.drawCDF(drawFittedPoints, scope.hasCorrectCoeffients);
                    }
                    else {
                        chartMaker.initialize(scope.selectedTerm, failureBranch, scope.selectedTermShadow);
                        chartMaker.drawPDF(drawFittedPoints, scope.hasCorrectCoeffients);
                    }
                    scope.displayTable = chartMaker.fittedPointsOnCDF(chartMaker.inputData);
                    scope.displayTableShadow = null;
                    if (scope.selectedShadowInputData !== null) {
                        scope.displayTableShadow = chartMaker.fittedPointsOnCDF(chartMaker.shadowInputData);
                    }
                };
                function handleFittedPoints(chartMaker) {
                    var _a = scope.submissions, submissions = _a.submissions, shadowSubmissions = _a.shadowSubmissions;
                    var result = { main: null, shadow: null };
                    result.main = processFittedPoints(chartMaker, chartMaker.inputData.MetaLogOutputs.BaseCaseCDF[0], scope.mean, submissions ? submissions[scope.submissionIndex] : null, false);
                    if (scope.shadowNodeName) {
                        result.shadow = processFittedPoints(chartMaker, chartMaker.shadowInputData.MetaLogOutputs.BaseCaseCDF[0], scope.shadowMean, shadowSubmissions ? shadowSubmissions[scope.submissionIndex] : null, true);
                    }
                    return result;
                }
                function processFittedPoints(chartMaker, basecase, mean, submission, isShadow) {
                    var expectedValue = chartMaker.addDot('Expected Value', mean, 'cross', 'red', isShadow);
                    var submissionValue = chartMaker.addDot('Submission Value', submission, 'diamond', 'red', isShadow);
                    var fittedPoints = [
                        { name: 'Base Case', x: basecase[0], y: basecase[1] },
                    ];
                    if (expectedValue) {
                        fittedPoints.push({ name: 'Expected Value', x: expectedValue[0], y: expectedValue[1] });
                    }
                    if (submissionValue) {
                        fittedPoints.push({ name: 'Submission Value', x: submissionValue[0], y: submissionValue[1] });
                    }
                    return fittedPoints;
                }
                scope.generateItems = function () {
                    var allTermsExceptSelected = [];
                    var _loop_1 = function (i) {
                        if (scope.selectedTerm != scope.allFeasiblePanels[i].NumberOfTerms) {
                            allTermsExceptSelected.push({
                                'name': 'Use ' + scope.allFeasiblePanels[i].NumberOfTerms + ' Term Fit',
                                'callback': function () {
                                    scope.selectedTerm = scope.allFeasiblePanels[i].NumberOfTerms;
                                    scope.initMenu();
                                    if (!scope.showCDF) {
                                        scope.changeChart();
                                    }
                                    else {
                                        scope.drawMetalogGraph();
                                    }
                                }
                            });
                        }
                    };
                    for (var i = 0; i < scope.allFeasiblePanels.length; i++) {
                        _loop_1(i);
                    }
                    return allTermsExceptSelected;
                };
                scope.displayName = function () {
                    var name = "";
                    if (scope.showCDF) {
                        name = "Show Probability Density Function";
                    }
                    else {
                        name = "Show Cumulative Distribution Function";
                    }
                    return name;
                };
                scope.displayForFailureBranch = function () {
                    return [
                        {
                            'name': scope.showTable ? 'Hide Table' : 'Show Table',
                            'toggle': scope.showTable ? 'Show Table' : 'Hide Table',
                            'callback': function () {
                                scope.showTable = !scope.showTable;
                                scope.showTableOnReload = angular.copy(scope.showTable);
                                scope.actionMenuItemOnReload = angular.copy(scope.actionMenuItem);
                                scope.initMenu();
                                $timeout(function () {
                                    $('[data-toggle="popover"]').popover();
                                }, 200);
                            }
                        }, {
                            'name': scope.displayName(),
                            'toggle': scope.displayName(),
                            'callback': function () {
                                scope.showCDF = !scope.showCDF;
                                scope.showFittedPointsHelp = false;
                                scope.showTable = true;
                                scope.initMenu();
                                scope.changeChart();
                            }
                        }
                    ];
                };
                scope.initMenu = function () {
                    scope.menu = [
                        {
                            'name': 'Display',
                            'items': scope.displayForFailureBranch()
                        }, {
                            'name': 'Export',
                            'items': [{
                                    'name': 'Chart',
                                    'callback': function () {
                                        scope.exportCharts();
                                    }
                                }, {
                                    'name': 'Table',
                                    'callback': function () {
                                        scope.exportCsv();
                                    }
                                }, {
                                    'name': 'Table EU',
                                    'callback': function () {
                                        scope.exportCsv(true);
                                    }
                                }]
                        }
                    ];
                    var fitList = scope.generateItems();
                    if (fitList.length > 0) {
                        scope.menu.splice(1, 0, {
                            'name': 'Fit',
                            'items': fitList
                        });
                    }
                };
            }
        };
    }]);
//# sourceMappingURL=metalog-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/metalog/app/js/plumbing/metalog-directive.js